import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from "react-hook-form";
import { TextArea } from "../../../../components/Inputs";
import { useTranslations } from "../../../../providers/useTranslations";
import styles from "./LoyaltyContactFormTextArea.module.scss";
export const LoyaltyContactFormTextArea = ({ id, label, required, validationErrorMessage, placeholder = "", }) => {
    const { control } = useFormContext();
    const { __ } = useTranslations();
    const handleChangeValue = (e, onChange) => {
        const inputValue = e.target.value;
        onChange({
            question: label,
            answers: [inputValue],
        });
    };
    const validateQuestionField = (value) => {
        const answer = value?.answers?.[0]?.trim();
        if (!answer && required) {
            return validationErrorMessage ?? __("contact.form.requiredmessage");
        }
        return true;
    };
    return (_jsx("div", { className: styles.textareaWrapper, children: _jsx(Controller, { name: id, control: control, defaultValue: { question: label, answers: [""] }, rules: {
                validate: validateQuestionField,
            }, render: ({ field, fieldState: { error } }) => (_jsx(TextArea, { ...field, id: id, label: label, isError: !!error, errorText: error?.message, isOptional: !required, isHelperTextVisible: true, value: field.value?.answers?.[0] || "", placeholder: placeholder, onChange: (e) => handleChangeValue(e, field.onChange) })) }) }));
};
//# sourceMappingURL=LoyaltyContactFormTextArea.js.map